/**
 * @file 文档页页面面包屑hooks
 * @author wanzhongyun
 */
import {useLayoutEffect, useMemo, useState} from 'react';
import {IDocumentMenuItem} from '../../type';
import innerText from '../../../../utils/inner-text';

const useBreadcrumbsListHooks = (documentDom?: HTMLElement) => {
    const [
        breadcrumbsList,
        setBreadcrumbsList
    ] = useState<IDocumentMenuItem[]>([]);

    useLayoutEffect(() => {
        if (!documentDom) {
            return;
        }
        const breadcrumbsDom = documentDom.querySelector(':scope .wy-breadcrumbs');
        if (!breadcrumbsDom) {
            return;
        }
        const breadcrumbsItemDoms: HTMLLIElement[] = Array.from(breadcrumbsDom.querySelectorAll(':scope > li'));
        const needItemDoms = breadcrumbsItemDoms.slice(1, -1);
        const breadcrumbsItems: IDocumentMenuItem[] = needItemDoms.map(
            (item, index) => {
                let title = innerText(item);
                let link = '';

                const aDom: HTMLAnchorElement | null = item.querySelector(':scope > a');
                if (aDom) {
                    title = innerText(aDom);
                    link = aDom.href.replace(window.location.origin, '');
                }

                const key = `$${index}${title}`;

                return {
                    key,
                    title,
                    link,
                    children: []
                };
            }
        );

        const currentLang = (window as any).docInfo?.lang || '';
        const defaultItem: IDocumentMenuItem = {
            key: '-1',
            title: currentLang.match(/^zh/g) ? '文档' : 'Document',
            link: '',
            children: []
        };

        setBreadcrumbsList([
            defaultItem,
            ...breadcrumbsItems
        ]);

        if (breadcrumbsDom && breadcrumbsDom.parentNode) {
            breadcrumbsDom.parentNode.removeChild(breadcrumbsDom);
        }

    }, [documentDom]);

    return useMemo(() => ({
        breadcrumbsList,
        setBreadcrumbsList
    }), [breadcrumbsList, setBreadcrumbsList]);
};

export default useBreadcrumbsListHooks;
